import { AfterViewInit, Directive, ElementRef, HostBinding } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject, combineLatest, filter, map, startWith, switchMap, takeUntil } from 'rxjs';
import { FormControlService } from '../form-control.service';

@Directive({
  selector: '[ssFormLabel]',
})
export class FormLabelDirective implements AfterViewInit {

  private readonly _destroy = new Subject<void>()

  get htmlElement() {
    return this._elementRef.nativeElement;
  }

  readonly langChangeObs = this._translateService.onDefaultLangChange.pipe(
    startWith(this._translateService.defaultLang)
  )

  constructor(
    private readonly _formControlService: FormControlService,
    private readonly _translateService: TranslateService,
    private readonly _elementRef: ElementRef<any>,
  ) {

    combineLatest([this._formControlService.labelObs, this.langChangeObs])
      .pipe(
        map(([label]) => label),
        filter(Boolean),
        switchMap(labelKey => this._translateService.get(labelKey)),
        takeUntil(this._destroy)
      )
      .subscribe((label) => {
        if (this.htmlElement) {
          this.htmlElement.innerHTML = label;
        }
        this.label = label
      })
  }

  @HostBinding('innerHTML') label?: string


  ngAfterViewInit(): void {
    this._elementRef.nativeElement.innerHTML = this.label || '';
  }

  ngOnDestroy() {
    this._destroy.next()
    this._destroy.complete()
  }
}
